import { render, staticRenderFns } from "./HarvestReception.vue?vue&type=template&id=b36f9458"
import script from "./HarvestReception.vue?vue&type=script&lang=js"
export * from "./HarvestReception.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports